module.exports = __webpack_public_path__ + "img/info_square.cd505ed2.svg";